import {
  LESSON_SET_INFO,
} from './action_types';

export const lessonSetInfo = payload => ({
  type: LESSON_SET_INFO,
  payload,
});



// WEBPACK FOOTER //
// ./src/modules/lessons/cards/LessonCard/actions.js